/**
 * Logikk for AI Action Recommendation Engine
 * Analyserer mønstre på tvers av indekser og foreslår spesifikke intervensjoner.
 */

export const ACTION_TYPES = {
  LEADERSHIP: { label: 'Leadership Coaching', icon: 'Award', color: 'indigo' },
  MEDIATION: { label: 'Conflict Mediation', icon: 'ShieldAlert', color: 'rose' },
  WORKSHOP: { label: 'Psychological Safety Workshop', icon: 'Users', color: 'emerald' },
  RESTRUCTURING: { label: 'Workload Restructuring', icon: 'Layers', color: 'orange' },
  COMMUNICATION: { label: 'Communication Training', icon: 'MessageCircle', color: 'cyan' }
};

export const analyzePatterns = (metrics) => {
  const patterns = [];
  
  // Pattern 1: High Stress + Low Leadership
  if (metrics.stress > 70 && metrics.we < 50) {
    patterns.push({
      id: 'p1',
      title: 'Leadership Exhaustion Pattern',
      desc: 'Høyt stress kombinert med lav WE-score indikerer at ledere mangler kapasitet til å støtte teamet.',
      challenge: 'Leadership Challenges'
    });
  }

  // Pattern 2: Low Safety + High Conflict
  if (metrics.safety < 45 && metrics.conflict > 60) {
    patterns.push({
      id: 'p2',
      title: 'Communication Breakdown',
      desc: 'Lav psykologisk trygghet gjør at konflikter forblir uløste og eskalerer under overflaten.',
      challenge: 'Organizational Patterns'
    });
  }

  // Pattern 3: High Workload Stress
  if (metrics.stress > 75) {
    patterns.push({
      id: 'p3',
      title: 'Systemic Overload',
      desc: 'Stressnivået indikerer at den operative modellen ikke lenger er bærekraftig.',
      challenge: 'Problem Areas'
    });
  }

  return patterns;
};

export const getPriorityInterventions = (metrics) => {
  const actions = [];

  if (metrics.conflict > 65) {
    actions.push({
      ...ACTION_TYPES.MEDIATION,
      priority: 'Critical',
      reason: 'Konfliktnivå overstiger toleransegrense for produktiv drift.'
    });
  }

  if (metrics.safety < 40) {
    actions.push({
      ...ACTION_TYPES.WORKSHOP,
      priority: 'High',
      reason: 'Kritisk lav trygghet hindrer informasjonsflyt og innovasjon.'
    });
  }

  if (metrics.we < 55) {
    actions.push({
      ...ACTION_TYPES.LEADERSHIP,
      priority: 'High',
      reason: 'Behov for å styrke lederstøtte i en krevende periode.'
    });
  }

  if (metrics.stress > 70) {
    actions.push({
      ...ACTION_TYPES.RESTRUCTURING,
      priority: 'Medium',
      reason: 'Arbeidspresset må justeres for å unngå sykefravær.'
    });
  }

  return actions;
};

export const generateActionPlan = (deptName, interventions) => {
  return {
    department: deptName,
    timeline: [
      { week: 'Uke 1-2', title: 'Diagnose & Stabilisering', actions: interventions.filter(a => a.priority === 'Critical').map(a => a.label) },
      { week: 'Uke 3-6', title: 'Kulturbygging', actions: interventions.filter(a => a.priority === 'High').map(a => a.label) },
      { week: 'Uke 8+', title: 'Strukturelle endringer', actions: interventions.filter(a => a.priority === 'Medium').map(a => a.label) }
    ]
  };
};